var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7769 11.465C10.1079 11.465 9.4409 11.244 8.8829 10.802L4.3979 7.18599C4.0749 6.92599 4.0249 6.45299 4.2839 6.13099C4.5449 5.80999 5.0169 5.75899 5.3389 6.01799L9.8199 9.62999C10.3829 10.076 11.1759 10.076 11.7429 9.62599L16.1789 6.01999C16.5009 5.75699 16.9729 5.80699 17.2349 6.12899C17.4959 6.44999 17.4469 6.92199 17.1259 7.18399L12.6819 10.796C12.1199 11.242 11.4479 11.465 10.7769 11.465Z",
    fill: "#9E9E9E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_278_849",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H21.4999V19.5H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_278_849)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83889 18H15.6589C15.6609 17.998 15.6689 18 15.6749 18C16.8159 18 17.8279 17.592 18.6039 16.817C19.5049 15.92 19.9999 14.631 19.9999 13.188V6.32C19.9999 3.527 18.1739 1.5 15.6589 1.5H5.84089C3.32589 1.5 1.49989 3.527 1.49989 6.32V13.188C1.49989 14.631 1.99589 15.92 2.89589 16.817C3.67189 17.592 4.68489 18 5.82489 18H5.83889ZM5.82189 19.5C4.27889 19.5 2.90089 18.94 1.83689 17.88C0.651893 16.698 -0.000106812 15.032 -0.000106812 13.188V6.32C-0.000106812 2.717 2.51089 0 5.84089 0H15.6589C18.9889 0 21.4999 2.717 21.4999 6.32V13.188C21.4999 15.032 20.8479 16.698 19.6629 17.88C18.5999 18.939 17.2209 19.5 15.6749 19.5H15.6589H5.84089H5.82189Z",
    fill: "#9E9E9E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.0eb11d002bc7ee08feca32f3c1978977.svg";
export { ForwardRef as ReactComponent };